import GC, { dateTimeFormat, nsColorConstants } from './GlobalConstant';
import toLower from 'lodash/toLower';
import transactionCode from './transactionCode.json';
import moment from 'moment';
import { AMLS_MODULES } from '../pages/app/appUtils';
import { castArray, orderBy, uniqBy } from 'lodash';
import { isEmptyNullUndef } from '../services/util';
import { getSelectedResources } from './resourceManager';
import { getStrategyType } from './localStorageUtils';

const { crsResources, nsResources, sandboxResources, tmResources } =
  getSelectedResources();

export const tmColorFinder = (text) => {
  switch (toLower(text)) {
    case 'total alerts':
    case 'alerts':
    case 'alert':
      return GC.alertColor;
    case 'issue':
      return GC.issueColor;
    case 'noissue':
    case 'no issue':
      return GC.noIssueColor;
    case 'str':
    case 'str filed':
      return GC.strColor;
    case 'anomaly':
    case 'anomlay':
    case 'anomalies':
      return GC.anomalyColor;
    case 'level_1':
    case 'level1':
    case 'auto_closed':
    case 'auto closed':
      return GC.autoCloseColor;
    case 'conversion':
      return GC.conversionColor;
    case 'no. of transactions':
    case '':
      return GC.noColor;
    case 'avg alerts disposed':
    case 'avg_alerts_disposed':
    case 'avg minutes taken':
    case 'avg_minutes_taken':
    case 'avg aged alerts':
    case 'avg_aged_alerts':
    case 'efficiency rate':
    case 'efficiency_rate':
      return GC.noIssueColor;
    case 'aged alerts':
    case 'aged_alerts':
      return 'rgba(236, 48, 25, 0.8)';
    default:
      return GC.randomColor();
  }
};

export const fillColorForPredictionLevel = (alertType, level) => {
  let alpha = 0;
  switch (toLower(level)) {
    case 'l1':
      alpha = 0.4;
      break;
    case 'l2':
      alpha = 0.8;
      break;
    case 'l3':
      alpha = 1;
      break;
    default:
      break;
  }

  switch (toLower(alertType)) {
    case 'anomaly':
    case 'anomlay':
    case '1':
    case 1:
      return GC.anomalyProgressColor;
    case 'alert':
    case '0':
    case 0:
      return `rgba(232, 82, 82, ${alpha})`;
    default:
      return GC.strProgressColor;
  }
};

export const formatNumeric = (s) => {
  //input eg: 250000=>250,000  1234.5678=>1,234.5678
  if (s) {
    const parts = s.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  } else {
    return '0';
  }
};
export const formatDecimal = (n, M) => {
  if (n) {
    const x = parseFloat(n);
    return parseFloat(x.toFixed(M));
  }

  return n;
};
export const extractDestinationCode = (s) => {
  if (s == null) return '';
  let output;
  let parts = s.split('-');
  if (parts.length > 1) {
    output = parts[parts.length - 1];
    return output.trim();
  }
  return s;
};

export const mapFileTypeClass = (f) => {
  //name selection

  const suffix = f.name.slice(f.name.lastIndexOf('.'));
  switch (suffix.toLowerCase()) {
    case '.pdf':
      return 'fa-file-pdf-o';
    case '.zip':
      return 'fa-file-archive-o';
    case '.txt':
      return 'fa-file-text-o';
    case '.jpg':
    case '.png':
      return 'fa-file-image-o';
    case '.xlsx':
    case '.xls':
      return 'fa-file-excel-o';
    case '.docx':
    case '.doc':
      return 'fa-file-word-o';
    case '.pptx':
    case '.ppt':
      return 'fa-file-powerpoint-o';
    //type selection
    default: {
      if (f.type.indexOf('text') == 0) {
        return 'fa-file-text-o';
      }
      if (f.type.indexOf('image') == 0) {
        return 'fa-file-image-o';
      }
      if (f.type.indexOf('audio') == 0) {
        return 'fa-file-audio-o';
      }
      if (f.type.indexOf('video') == 0) {
        return 'fa-file-video-o';
      }
      return 'fa-file-o ';
    }
  }
};

export const calculateFileSize = (s) => {
  let size = (s / 1024).toFixed(2);
  if (size < 1024) return size + 'KB';
  else {
    size = (size / 1024).toFixed(2);
    if (size < 1024) return size + 'MB';
    else {
      size = (size / 1024).toFixed(2);
      return size + 'GB';
    }
  }
};

export const isUiResourceAvailable = (uiResource, arrayOfUiResources) => {
  let isAvailable = false;
  if (uiResource && Array.isArray(arrayOfUiResources)) {
    arrayOfUiResources.forEach((currentUiResource) => {
      if (currentUiResource === uiResource) {
        isAvailable = true;
      }
    });
  }

  return isAvailable;
};

export const nsColorFinder = (name) => {
  switch (toLower(name)) {
    case 'total alerts':
    case 'alerts':
    case 'alert':
    case 'avg_alerts_throughput':
    case 'avg_aged_alerts':
    case 'aged_alerts':
    case 'totalalerts':
      return nsColorConstants.alerts;
    case 'total hits':
    case 'totalhits':
    case 'hits':
    case 'avg_hits_alerts':
      return nsColorConstants.hits;
    case 'truehits':
    case 'truehits':
    case 'true_hits':
      return nsColorConstants.trueHits;
    case 'falsehits':
    case 'falsehits':
    case 'false_hits':
      return nsColorConstants.falseHits;
    case 'autoclose':
    case 'auto_closed':
    case 'level_1':
    case 'level1':
    case 'auto_close':
    case 'autoclosed':
      return nsColorConstants.autoClosed;
    case 'undetermined':
      return nsColorConstants.undetermined;
    case 'hitsyield':
    case 'hityield':
    case 'hits_yield':
      return nsColorConstants.hitsYield;
    case 'avg_time':
      return nsColorConstants.time;
    case 'current_system':
      return GC.ruleBasedColor;
    default:
      return nsColorConstants.randomColor;
  }
};

const transitColor = (color1, color2, factor) => {
  let result = color1.slice();
  for (let i = 0; i < 3; i++) {
    result[i] = Math.round(result[i] + factor * (color2[i] - color1[i]));
  }
  return result;
};

export const interpolateColors = (color1, color2, steps) => {
  if (steps && steps >= 2) {
    let stepFactor = 1 / (steps - 1);
    let colorArray = [];

    color1 = color1.match(/\d+/g).map(Number);
    color2 = color2.match(/\d+/g).map(Number);

    for (let i = 0; i < steps; i++) {
      colorArray.push(transitColor(color1, color2, stepFactor * i));
    }
    return colorArray;
  } else return [];
};

export const findMeanIndex = (data) => {
  const { mean, data_points } = data;
  for (let k = 0; k < data_points.length - 1; k++) {
    if (
      mean - data_points[k].value >= 0 &&
      mean - data_points[k + 1].value <= 0
    ) {
      if (mean - data_points[k].value <= (mean - data_points[k + 1].value) * -1)
        return k;
      else return k + 1;
    }
  }
  return 0;
};

export const hasPermission = (authentication, modu, func) => {
  const permissions = authentication?.payload?.data?.permissions || [];
  const role = authentication?.payload?.data?.role;

  let isAllowed = true;
  for (let i = 0; i < permissions.length; i++) {
    const permission = permissions[i];
    const permissionModu = permission.module;
    if (permissionModu.name == modu) {
      isAllowed = permissionModu.roles.indexOf(role) > -1;

      if (!func) break;

      const functions = permission.functions;
      for (let j = 0; j < functions.length; j++) {
        const permissionFunc = functions[j];
        if (func == permissionFunc.name) {
          isAllowed = permissionFunc.roles.indexOf(role) > -1;
          break;
        }
      }
      break;
    }
  }

  return isAllowed;
};

export const hasResourceScope = (operations = [], resourceCode) => {
  return operations.includes(resourceCode);
};

export const tmHasPermission = (authentication) => {
  const strategyType = getStrategyType() || 'hybrid'; // possible values 'hybrid' or 'keycloak'
  const allowedResources = [
    tmResources.APP_3_RESOURCE_UI_TM_ALERT_LIST_ALERTS,
    tmResources.APP_3_RESOURCE_UI_TM_ALERT_LIST_ANOMALIES,
    tmResources.APP_3_RESOURCE_UI_TM_INVESTIGATION_PAGE,
    tmResources.APP_3_RESOURCE_UI_TM_DASHBOARD,
    tmResources.APP_3_RESOURCE_UI_TM_CONFIGURATION
  ];
  if (
    authentication &&
    Array.isArray(authentication.data) &&
    authentication.data.length > 0
  ) {
    for (const attribute of authentication.data) {
      const resource = attribute.details?.resource;
      if (!resource) {
        console.warn('No resource available');
        continue;
      }
      if (strategyType?.toLowerCase() === 'hybrid') {
        if (allowedResources.includes(resource.resourceCode)) {
          return true; // Early return for performance
        }
      } else if (strategyType?.toLowerCase() === 'keycloak') {
        if (
          Array.isArray(resource.operations) &&
          resource.operations.some((op) => allowedResources.includes(op))
        ) {
          return true; // Early return for performance
        }
      }
    }
  }
  return false;
};

export const crsHasPermission = (authentication) => {
  const strategyType = getStrategyType() || 'hybrid';
  const allowedResources = [
    crsResources.APP_3_RESOURCE_UI_CRS_DASHBOARD,
    crsResources.APP_3_RESOURCE_UI_CRS_CUSTOMER_LIST,
    crsResources.APP_3_RESOURCE_UI_CRS_CUSTOMER_DETAIL,
    crsResources.APP_3_RESOURCE_UI_CRS_RISK_INDICATOR_CONFIGURATION,
    crsResources.APP_3_RESOURCE_UI_CRS_GLOBAL_SETTINGS
  ];

  if (
    authentication &&
    Array.isArray(authentication.data) &&
    authentication.data.length > 0
  ) {
    for (const attribute of authentication.data) {
      const resource = attribute.details?.resource;
      if (!resource) {
        console.warn('No resource available');
        continue;
      }
      if (strategyType?.toLowerCase() === 'hybrid') {
        if (allowedResources.includes(resource.resourceCode)) {
          return true;
        }
      } else if (strategyType?.toLowerCase() === 'keycloak') {
        if (
          Array.isArray(resource.operations) &&
          resource.operations.some((op) => allowedResources.includes(op))
        ) {
          return true;
        }
      }
    }
  }
};

export const nsHasPermission = (authentication) => {
  const strategyType = getStrategyType() || 'hybrid'; // possible values 'hybrid' or 'keycloak'
  const allowedResources = [
    nsResources.APP_3_RESOURCE_UI_NS_ALERTS_LIST,
    nsResources.APP_3_RESOURCE_UI_NS_INVESTIGATION_PAGE,
    nsResources.APP_3_RESOURCE_UI_NS_RISK_VIEW,
    nsResources.APP_3_RESOURCE_UI_NS_IAD_GLOBAL_SETTINGS
  ];

  if (
    authentication &&
    Array.isArray(authentication.data) &&
    authentication.data.length > 0
  ) {
    for (const attribute of authentication.data) {
      const resource = attribute.details?.resource;
      if (!resource) {
        console.warn('No resource available');
        continue;
      }
      if (strategyType?.toLowerCase() === 'hybrid') {
        if (allowedResources.includes(resource.resourceCode)) {
          return true;
        }
      } else if (strategyType?.toLowerCase() === 'keycloak') {
        if (
          Array.isArray(resource.operations) &&
          resource.operations.some((op) => allowedResources.includes(op))
        ) {
          return true;
        }
      }
    }
  }

  return false;
};

export const sandboxHasPermission = (authentication) => {
  const strategyType = getStrategyType() || 'hybrid'; // possible values 'hybrid' or 'keycloak'
  const allowedResources = [
    sandboxResources.APP_3_RESOURCE_UI_SCREENING_SANDBOX
  ];
  if (
    authentication &&
    Array.isArray(authentication.data) &&
    authentication.data.length > 0
  ) {
    for (const attribute of authentication.data) {
      const resource = attribute.details?.resource;
      if (!resource) {
        console.warn('No resource available');
        continue;
      }
      if (strategyType?.toLowerCase() === 'hybrid') {
        if (allowedResources.includes(resource.resourceCode)) {
          return true; // Early return for performance
        }
      } else if (strategyType?.toLowerCase() === 'keycloak') {
        if (
          Array.isArray(resource.operations) &&
          resource.operations.some((op) => allowedResources.includes(op))
        ) {
          return true; // Early return for performance
        }
      }
    }
  }

  return false;
};

export const mapTransactionCode = (code) => {
  return transactionCode[code] ? transactionCode[code] : 'Unknown';
};

export const mapTransactionName = (name) => {
  for (const key of Object.keys(transactionCode)) {
    if (transactionCode[key] === name) {
      return key;
    }
  }
  return 'UnknownKey';
};

export const convertToUtcTime = (date) => {
  return moment(date, ['DD/MM/YYYY HH:mm:ss.SSS']).utc().format(dateTimeFormat);
};

export const getValue = (val, defaultEmptyResult = '-') => {
  if (val === 'null' || val === undefined || val === '' || val === null) {
    return defaultEmptyResult;
  }
  return val;
};

/**
 * getAllowedPages using Authentication API
 * @param authentication
 * @param filterCriteria
 * @returns {{homeUrl: string, sortedArray: Array}}
 */
export const getAllowedPages = (authentication, filterCriteria = null) => {
  const { data: authAttributes = [] } = authentication || {};
  const allowedPages = [];
  if (
    authentication &&
    Array.isArray(authAttributes) &&
    authAttributes.length > 0
  ) {
    authAttributes.forEach((attribute, index) => {
      const { details } = attribute;
      const { resource } = details || {};
      const { resourceCode } = resource || {};
      Object.keys(AMLS_MODULES).forEach((eachModule) => {
        Object.keys(AMLS_MODULES[eachModule]).forEach((page) => {
          const pageObject = AMLS_MODULES[eachModule][page];
          if (pageObject.code === resourceCode) {
            allowedPages.push(pageObject);
          }
        });
      });
    });
  }

  const sortedArray = orderBy(allowedPages, ['priority'], ['asc']);
  let filteredPagesArray = [];
  if (!isEmptyNullUndef(filterCriteria)) {
    filteredPagesArray = sortedArray.filter((item) => {
      return item.module === filterCriteria;
    });
  }

  const uniqueModules = uniqBy(filteredPagesArray, 'text');
  if (uniqueModules.length > 0) {
    return {
      sortedArray: uniqueModules,
      homeUrl: uniqueModules[0].homeURL
    };
  } else {
    return {
      sortedArray,
      homeUrl: sortedArray[0].homeURL
    };
  }
};

export const getVersionNumber = () => {
  const versionNumber = localStorage.getItem('version-number') || '';
  return versionNumber;
};

export const getTenantId = () => {
  const tenantId = localStorage.getItem('tenant-id') || '';
  return tenantId;
};

// Please use this to check the authentication reducer's data array for resourceCode you are looking for
export const isResourceAvailable = (authenticationObject, resourceCode) => {
  // flag to flip if resource is found
  // debugger
  let policyHasResource = false;

  // check whether the authenticationObject and resourceCode are passed and..
  // if it's an array and it's not empty
  if (
    authenticationObject &&
    resourceCode &&
    Array.isArray(authenticationObject.data) &&
    authenticationObject.data.length > 0
  ) {
    // loop through the list
    const listOfPolicies = authenticationObject.data;
    listOfPolicies.forEach((policy) => {
      const scopes = policy.details?.resource?.operations
        ? policy.details.resource.operations
        : null;

      // if resourceCode is found, return the flag as true
      if (scopes && scopes.includes(resourceCode)) {
        policyHasResource = true;
      }
    });
  }

  return policyHasResource;
};

// Please use this to check the authentication reducer's data array for resourceCode you are looking for
export const hasResourceOperation = (
  authenticationObject,
  resourceCode,
  resourceOperationToBeChecked
) => {
  // flag to flip if resource is found
  let hasResourceOperation = false;

  // check whether the authenticationObject, resourceCode and resourceOperationToBeChecked are passed and..
  // if authenticationObject is an array and it's not empty
  if (
    authenticationObject &&
    resourceCode &&
    Array.isArray(authenticationObject.data) &&
    authenticationObject.data.length > 0
  ) {
    // loop through the list
    const listOfPolicies = authenticationObject.data;
    listOfPolicies.forEach((policy) => {
      const policyResourceCode = policy.details?.resource?.resourceCode
        ? policy.details.resource.resourceCode
        : null;

      const policyResourceOperations = policy.details?.resource?.operations
        ? policy.details.resource.operations
        : [];

      // if resourceCode is found, check its operations against resourceOperationToBeChecked
      if (
        policyResourceCode &&
        policyResourceCode === resourceCode &&
        Array.isArray(policyResourceOperations)
      ) {
        policyResourceOperations.forEach((operation) => {
          if (operation === resourceOperationToBeChecked) {
            hasResourceOperation = true;
          }
        });
      }
    });
  }

  return hasResourceOperation;
};

// Please use this to check the authentication reducer's data array for attributeVlue you are looking for
export const hasAttributeValue = (
  authenticationObject,
  resourceCode,
  attributeCode
) => {
  let hasAttributeValueFlag = false;
  // check whether the authenticationObject, resourceCode and resourceOperationToBeChecked are passed and..
  // if authenticationObject is an array and it's not empty
  if (
    authenticationObject &&
    resourceCode &&
    Array.isArray(authenticationObject.data) &&
    authenticationObject.data.length > 0
  ) {
    //check each authentication object
    authenticationObject.data.forEach((data) => {
      //check if authentication object has the matching resource code
      const scopes = data.details?.resource?.operations
        ? data.details.resource.operations
        : null;
      if (scopes && scopes.includes(resourceCode)) {
        // if resoucrce code is found then check if the attributeCode passed is available then set the flag to true
        data.attributes.forEach((attribute) => {
          if (attribute.attributeValues.includes(attributeCode)) {
            hasAttributeValueFlag = true;
          }
        });
      }
    });
  }
  return hasAttributeValueFlag;
};

export const hasAttributeValueByAttributeKey = (
  authenticationObject,
  resourceCode,
  attributeKey,
  attributeValue
) => {
  let hasAttributeValueFlag = false;
  // check whether the authenticationObject, resourceCode and resourceOperationToBeChecked are passed and..
  // if authenticationObject is an array and it's not empty
  if (
    authenticationObject &&
    resourceCode &&
    Array.isArray(authenticationObject.data) &&
    authenticationObject.data.length > 0
  ) {
    //check each authentication object
    authenticationObject.data.forEach((data) => {
      //check if authentication object has the matching resource code
      const scopes = data.details?.resource?.operations
        ? data.details.resource.operations
        : null;
      if (scopes && scopes.includes(resourceCode)) {
        // if resoucrce code is found then check if the attributeValue passed is available then set the flag to true
        data.attributes.forEach((attribute) => {
          if (
            attribute.attributeKey === attributeKey &&
            attribute.attributeValues.includes(attributeValue)
          ) {
            hasAttributeValueFlag = true;
          }
        });
      }
    });
  }
  return hasAttributeValueFlag;
};

export const hasResource = (policies = [], resourceCode) =>
  policies.some((policy) =>
    castArray(resourceCode).some((code) =>
      policy?.details?.resource?.operations?.includes(code)
    )
  );
